import React from 'react';
import TransactionList from './partials/TransactionList';
import DirectPaymentLink from '../Payment/DirectPaymentLink';

export default function Transaction() {
    return (
        <div className="mx-3 mt-4">
            <div className="dashboard-header d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-2">
                <div className="pageTitle">
                    <h1>Transactions</h1>
                </div>

                <div className="dashboard-actions d-flex align-items-center gap-3">
                    <DirectPaymentLink />
                </div>
            </div>

            <TransactionList />
        </div>
    );
}